export const routes = {
  home: "/",
  ristorante: "/il-ristorante",
  team: "/team",
  menu: "/menu",
  cantina: "/la-cantina",
  galleria: "/galleria",
  contatti: "/contatti",
  prenota: "/prenota",
  privacy: "/privacy",
  cookie: "/cookie",
} as const;
